/* eslint eqeqeq: "warn", no-plusplus: "warn" */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["player"] }] */
export default class {
    constructor(booking) {
        this.playerSuggestions = [];
        this.booking = booking;
        this.activeIndex = 0;

        this.handleTyping = _.debounce(this.handleTyping.bind(this), 500);
    }

    filteredSuggestions() {
        const uuids = this.currentUuids();
        const unique = _.filter(this.playerSuggestions, (o, i) => _.indexOf(uuids, o.id) == -1);

        // Only return players entitled to play.
        return _.filter(unique, (o, i) => o.entitledToPlay);
    }

    /**
     * Search on member first name & update the suggestions list.
     *
     * @return {Void}
     */
    updateSuggestions(player) {
        this.clearSuggestions();

        // Update search result if at least 3 chars.
        if (player[this.nameKey].length >= 3) {
            this.booking.$api.gms.member.searchMembers({ [this.nameKey]: player[this.nameKey] })
            .then((response) => {
                if (response.data.result.errors) {
                    this.playerSuggestions = [];
                    return;
                }
                this.playerSuggestions = response.data.result.members;
            })
            .catch((error) => { });
        }
    }

    /**
     * Clears the suggestions list.
     *
     * @return {Void}
     */
    clearSuggestions() {
        this.playerSuggestions = [];
        this.activeIndex = 0;
    }

    /**
     * Handle a suggestion click event: Update player id and name and trigger player update event.
     *
     * @param  {String} playerId Player member id.
     * @param  {String} name
     * @return {Void}
     */
    onSuggestionClick(suggestionIndex, player) {
        this.setSuggestion(suggestionIndex, player);
    }

    /**
     * Update player id and name and trigger player update event.
     *
     * @param {Integer} suggestionIndex
     * @return {Void}
     */
    setSuggestion(suggestionIndex, player) {
        if (!this.playerSuggestions[suggestionIndex]) {
            return;
        }

        player.uuid = this.playerSuggestions[suggestionIndex].id;
        player.firstName = this.playerSuggestions[suggestionIndex].firstName;
        player.lastName = this.playerSuggestions[suggestionIndex].lastName;
        player.member = true;

        this.clearSuggestions();
    }

    /**
     * Reset the suggested player that has been chosen.
     *
     * @return {Void}
     */
    resetPlayer(player) {
        player.uuid = null;
        player.firstName = '';
        player.lastName = '';
        player.member = false;
        this.updateSuggestions(player);
    }

    /**
     * Handle field blur event: Clear suggestions with a small delay to allow a click event on a suggestion to fire still.
     *
     * @return {Void}
     */
    onFieldBlur(player, nameKey) {
        setTimeout(() => {
            this.clearSuggestions();
        }, 300);
    }

    /**
     * Handle field focus event: update suggestions to show them again if any.
     *
     * @return {Void}
     */
    onFieldFocus(player, nameKey) {
        this.player = player;
        this.nameKey = nameKey;

        this.updateSuggestions(player);
    }

    /**
     * Handle clicking on the reset icon.
     *
     * @return {Void}
     */
    onResetClick(player) {
        this.resetPlayer(player);
    }

    /**
     * Move to previous suggestion or wrap around the start or stay at 0 if there are no suggestions.
     *
     * @return {Void}
     */
    focusPreviousSuggestion() {
        if (this.activeIndex - 1 < 0) {
            if (this.playerSuggestions.length > 0) {
                this.activeIndex = this.playerSuggestions.length - 1;
                return;
            }
            this.activeIndex = 0;
            return;
        }
        this.activeIndex--;
    }

    /**
     * Move to next suggestion or wrap around the end or stay at 0 if there are no suggestions.
     *
     * @return {Void}
     */
    focusNextSuggestion() {
        if (this.activeIndex + 1 >= this.playerSuggestions.length) {
            this.activeIndex = 0;
            return;
        }
        this.activeIndex++;
    }

    /**
     * Handle keyup event on field, different actions on up/down arrows, return key or typing.
     *
     * @return {Void}
     */
    onFieldKeyup(player, event) {
        // Hitting return activates the current suggestion.
        if (event.keyCode == 13) {
            this.setSuggestion(this.activeIndex, player);
            return;
        }

        // Hitting return activates the current suggestion.
        if (event.keyCode == 27) {
            this.clearSuggestions();
            return;
        }

        // Hitting the up arrow key moves up.
        if (event.keyCode == 38) {
            this.focusPreviousSuggestion();
            return;
        }

        // Hitting the down arrow key moves down.
        if (event.keyCode == 40) {
            this.focusNextSuggestion();
            return;
        }

        // Ignore irrelevant keys.
        // Note: http://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
        if (
            (event.keyCode < 48 && event.keyCode != 8) // any control keys except backspace
            || event.keyCode == 91 // left window key
            || event.keyCode == 92 // right window key
            || event.keyCode == 93 // select key
            || (event.keyCode >= 112 && event.keyCode <= 123) // f1 - f12
            || event.keyCode == 144 // num lock
            || event.keyCode == 145 // scroll lock
        ) return;

        this.handleTyping(player);
    }

    /**
     * Clear player id and trigger player update event, update search suggestions.
     *
     * @return {Void}
     */
    handleTyping(player) {
        this.updateSuggestions(player);
    }

    currentUuids() {
        // Create an array of all the players in all the flights.
        const flat = _.flatMap(this.booking.flights, (o, i) => o.players);

        // Return a collection of uuids.
        return _.map(_.filter(flat, 'uuid'), 'uuid');
    }
}
